export default __webpack_public_path__ + "media/titles/title_4_locale_pt-a65b0cbd.png";